import Marquee from "react-fast-marquee";
import { MARQUEE_WORDS } from "@/data/content";
import { TEST_IDS } from "@/constants/testIds";

export default function EditorialMarquee() {
  return (
    <section
      data-testid={TEST_IDS.marquee}
      aria-label="What we do"
      className="border-y border-[#E5E1DA] bg-[#F3EFE9] py-8 md:py-10 overflow-hidden"
    >
      <Marquee gradient={false} speed={30} pauseOnHover>
        {MARQUEE_WORDS.map((word, i) => (
          <span
            key={`${word}-${i}`}
            className="inline-flex items-center gap-8 pr-16 font-serif-display text-[#787672]/90 italic"
            style={{ fontSize: "clamp(38px, 6vw, 88px)", lineHeight: 1 }}
          >
            {word}
            <span aria-hidden="true" className="text-[#E07A5F] not-italic font-sans font-light text-[0.55em] translate-y-[-4px]">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
